export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f2d1f5a6056094e9404de5f31857ce28487df321d&name=fetchTypeahead!'